var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCog24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    d: "m7.7 18.57-.46.45a.7.7 0 0 1-.96-.02L5 17.72a.7.7 0 0 1-.01-.96l.44-.47m2.28 2.28-.06.05m.06-.05.06-.06c.27-.26.77-.35 1.11-.21l.87.36c.34.14.63.56.64.93l.01.73c.01.38.32.68.7.68h1.8a.7.7 0 0 0 .7-.68l.01-.73c.01-.37.3-.79.64-.93l.87-.36c.34-.14.84-.05 1.11.21l.53.5c.26.26.7.26.96 0L19 17.71a.7.7 0 0 0 .02-.96l-.51-.53a1.12 1.12 0 0 1-.21-1.11l.36-.87c.14-.34.56-.63.93-.64l.73-.01a.7.7 0 0 0 .68-.7v-1.8a.7.7 0 0 0-.68-.7l-.73-.01c-.37-.01-.79-.3-.93-.64l-.36-.87c-.14-.34-.05-.84.21-1.11l.5-.53a.7.7 0 0 0 0-.96L17.71 5a.7.7 0 0 0-.96-.02l-.53.51c-.27.26-.77.35-1.11.21l-.87-.36a1.12 1.12 0 0 1-.64-.93l-.01-.73a.7.7 0 0 0-.7-.68h-1.8a.7.7 0 0 0-.7.68l-.01.73c-.01.37-.3.79-.64.93l-.87.36c-.34.14-.84.05-1.11-.21l-.53-.5a.7.7 0 0 0-.96 0L5 6.29a.7.7 0 0 0-.02.96l.51.53c.26.27.35.77.21 1.11l-.36.87c-.14.34-.56.63-.93.64l-.73.01a.7.7 0 0 0-.68.7v1.8c0 .38.3.69.68.7l.73.01c.37.01.79.3.93.64l.36.87c.14.34.05.84-.21 1.11l-.06.06m0 0-.05.06M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog24);
export default __webpack_public_path__ + "static/media/cog_24.caffa1a93dcd142e29f6f8e9a61b32fb.svg";
export { ForwardRef as ReactComponent };